<script setup lang="ts">
import LGMyStoryHero from "~/components/my-story/LGMyStoryHero.vue";
import LGMyStoryText from "~/components/my-story/LGMyStoryText.vue";

const { t } = useI18n()

const title = t('myStory.seo.title')
const description = t('myStory.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'index,follow',
})
</script>

<template>
    <div>
        <LGMyStoryHero/>
        <LGMyStoryText/>
    </div>
</template>

<style scoped>

</style>
